<template>
    <v-row justify="space-around">
        <v-col cols="auto">
            <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="1200">
                <template v-slot:default="dialog">
                    <v-card>
                        <v-toolbar color="primary" dark>سامانه مودیان</v-toolbar>
                        <v-card-title>
                            <div class="text1 px-10 pt-12 pb-5 bold">{{ title }}</div>
                        </v-card-title>
                        <v-card-text>
                            <div class="text1 px-10 py-5"> {{ p1 }}</div>
                            <div class="text1 px-10 py-5"> {{ p2 }}</div>
                            <div class="text1 px-10 py-3">{{ text3 }}</div>
                            <div class="text1 px-10 py-3">{{ text4 }} {{ telno }}</div>
                            <!-- <div class="text1 tel py-2">{{ telno }}</div> -->
                        </v-card-text>
                        <v-card-actions class="justify-end">
                            <v-btn text @click="dialog.value = false" :style="{ backgroundColor: '#ddd' }">متوجه
                                شدم</v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
export default {
    computed: {
        updateLink() {
            const linksData = this.$store.state.filesLinks;
            let link = null;
            for (let index = 0; index < linksData.length; index++) {
                const element = linksData[index];
                if (element.Name.trim().toLowerCase() === "autoupdatepazar") {
                    link = element.Link;
                }
            }
            return link;
        },
        howtoupdatepazarplusLink() {
            const linksData = this.$store.state.filesLinks;
            let link = null;
            for (let index = 0; index < linksData.length; index++) {
                const element = linksData[index];
                if (
                    element.Name.trim().toLowerCase() === "howtoupdatepazarplus"
                ) {
                    link = element.Link;
                }
            }
            return link;
        },
    },
    data() {
        return {
            dialog: true,
            title: "عرضه نسخه ابری و مستقل سامانه مودیان ",
            p1:
                "ارزانترین، سریعترین و آسانترین روش ثبت صورتحساب الکترونیک در نسخه ابری سامانه مودیان",
            p2: "نسخه ابری سامانه مودیان شرکت رقم سازان بصورت مستقل از نرم افزارهای فروشگاهی و حسابداری پازار عرضه گردیده و قابلیت ثبت صورتحساب الکترونیک به همراه عملیات اصلاحی ، ابطالی و برگشت از فروش را دارا میباشد. ",
            text3:
                "لطفا برای کسب اطلاعات بیشتر و دریافت نام کاربری و رمزعبور با واحد فروش تماس حاصل نمایید.",
            text4: "تماس:",
            telno: "7108-041",
        };
    },
};
</script>

<style scoped>
.text1 {
    text-align: justify;
    font-size: larger !important;
    font-weight: bold;
    line-height: 40px;
}

.text-link {
    line-height: 40px;
    color: blue;
}

.tel {
    padding-right: 100px;
}
</style>
